import { useCallback } from 'react';
import {
  useWorkflow,
  WORKFLOW_ACTIONS,
} from '../../../components/Admin/Workflows/Wizard/WorkflowContext';

const useWorkflowImperativeApi = () => {
  const { nodes, edges, dispatch } = useWorkflow();

  const resetWorkflow = useCallback(() => {
    dispatch({ type: WORKFLOW_ACTIONS.RESET_WORKFLOW });
  }, [dispatch]);

  const getWorkflowJsonData = useCallback(() => {
    const serializableNodes = nodes.map((node) => {
      const { data, ...rest } = node;
      const { label, ...dataWithoutLabel } = data || {};
      return { ...rest, data: dataWithoutLabel };
    });
    return { nodes: serializableNodes, edges };
  }, [nodes, edges]);

  return { resetWorkflow, getWorkflowJsonData };
};

export default useWorkflowImperativeApi;
